<template>
    <PageHeader :title="title" />

    <tablecustom 
        @search="searchB" 
        :dataParams="dataParams"
        :objParams="objParams"
        :columns="columns" 
        :rows="rows" 
        :pages="objPages"
        :showpag="true"
        :createdform="true" 
        @create="showAttrBox = true" 
        @open="open" 
        @remove="remove" 
        @changeFilter="changeFilter"  
        @getdata="getdata"
        @changelimit="changelimit"
    />

    <viewAttrbox 
        v-if="showModalview == true" 
        @close="showModalview = false" 
        :objCard="this.objCard" 
        :ifPrevopen="ifPrevopen" 
        :ifNextopen="ifNextopen" 
        @prevOpen="prevOpen" 
        @nextOpen="nextOpen" 
    ></viewAttrbox>

    <createAttributeBox 
        v-if="showAttrBox == true" 
        @close="showAttrBox = false"
    ></createAttributeBox> 

</template>

<script>
import PageHeader from "@/components/page-header";
import viewAttrbox from './view'
import createAttributeBox from './create'
import tablecustom from '@/components/globaltable/index';
import { ApiDocs } from '@/API.js';
import { storeS } from '@/store.js'
import { mutateReqDocs } from '@/usabilityScripts/globalMutate.js'

let apiServe = new ApiDocs();

export default {
    data() {
        return {
            title: this.$t('ApiDocs'),
            // data: {},
            rows: [],
            objCard: "",
            showModalview: false,
            showAttrBox: false,
            ifNextopen: "",
            ifPrevopen: "",
            objPages: "",
            dataParams: {
                status: false,
                page: "changelog"
            },
            objParams:{
                page: '1',
                pagelimit: '10',
                search: ''
            },
            columns: [
                {
                    name: 'ID',
                    text: "attributeId",
                    align: "left",
                    status: false,
                },
                {
                    name: this.$t("type"),
                    text: "type",
                    align: "left",
                    status: true,
                },
                {
                    name: this.$t("Point_name"),
                    text: "name",
                    align: "left",
                    status: true,
                },
                {
                    name: this.$t("description"),
                    text: "comment",
                    align: "left",
                    status: true,
                },
                {
                    name: this.$t("Required"),
                    text: "required",
                    align: "left",
                    status: true,
                    mutate: (item) => this.mutateReq(item)
                },
            ],
        };
    },
    components: {
        PageHeader,
        createAttributeBox,
        tablecustom,
        viewAttrbox
        // viewbox,
    },
    created(){
        this.getdata();
    },
    methods: {
        getdata(page){
            this.objParams.page = page != undefined ? page : '1';
            apiServe.getAttributes(this.objParams).then(result => {
                if(result.status === 'done') {
                    this.rows = result.data.items;
                    this.objPages = result.data;
                } else {
                    this.$toast.error(this.$t('error') + ` #380`);
                }
            })
        },
        changelimit: function(limit){
            this.objParams.pagelimit = limit;
            this.getdata();
        },
        open(e){
            var id = e.attributeId ? e.attributeId : e;
            this.ifPrevopen = id == this.rows[0].attributeId ? false : true;
            this.ifNextopen = id == this.rows[this.rows.length-1].attributeId ? false : true;

            apiServe.getAttribute(id).then(result =>{
                if(result.status == 'done'){
                    this.objCard = result.data
                    this.showModalview = true
                } else {
                    this.$toast.error(this.$t("error"))
                }
            })
        },
        prevOpen(){
            var current_id = this.objCard.attributeId;
            var prev_id = ''; 

            for(var value in this.rows){
                if(this.rows[value].attributeId == current_id){
                prev_id = this.rows[Number(value)-Number('1')].attributeId;
                }
            }
            this.open(prev_id);
        },
        nextOpen(){
            var current_id = this.objCard.attributeId;
            var next_id = '';

            for(var value in this.rows){
                if(this.rows[value].attributeId == current_id){
                next_id = this.rows[Number(value)+Number('1')].attributeId;
                }
            }
            this.open(next_id);
        },
        remove: function(e){
            apiServe.deleteUpdate(e.id).then(res => {
                if(res){
                this.$toast.success(this.$t('Removed'));
                this.getdata();
                }
            })
        },
        searchB(e){
            this.objParams.search = e
            this.getdata();
        },
        mutateReq(e){
            return mutateReqDocs(e)
        }
    },
    computed: {
        perms() {
            return storeS.perms
        }
    },
    mounted() {
        this.eventBus.on('saveAttr', (status) => {
            if(status == true) {
                this.getdata();
            }
        })
    },
};
</script>